<template>
    <div class="color-field color-field--hex" v-if="hex">
        <label class="color-field__label">Hex</label>
		<span class="color-field__meta editable-text">
			<input class="editable-text__input" 
				type="text" 
				size="1"
				:value="displayValue" 
				@input="updateField($event, 'value')">
		</span>
    </div>
</template>

<script>
    import Color          from "../../../../../Lib/Color";
    import BaseColorInput from "./BaseColorInput";

    export default {
        name: 'hex-field',
        extends: BaseColorInput,
        props: {
            disable: {
                default: false,
            }
        },

        data() {
            return {
                displayValue: '',
                colorType: 'hex',
            }
        },

        watch: {
            hex: {
                deep: true,
                handler() {
                    this.displayValue = this.hex.value;
                }
            }
        },

        computed: {
            hex() {
                return this.draft.hex();
            }
        },

        methods: {

            getValue() {
                return this.hex;
            },

            getSanitizedColor(hex) {
                hex.value = this.sanitize(hex.value);

                let color;

                if(this.isValid(hex.value)) {
                    color = Color.fromHex(hex);
                }

                return color;
            },

            sanitize(hex) {
                this.displayValue = hex;

                if(hex.indexOf('##') === 0) {
                    hex = hex.substr(1);
                }
                if(hex.length > 6) {
                    this.displayValue = hex.substr(0, 7);
                }
                if(hex.substr(0, 1) !== "#") {
                    this.displayValue = "#" + hex;
                }

                return this.displayValue;
            },

            isValid(hex) {
                return /^#([A-Fa-f0-9]{6})$/.test(hex);
            },

            onValueChange() {
                if(!this.validateHex()) {
                    return;
                }
                this.$emit('hex-changed', color, 'hex');
            },
        },
    }
</script>